import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Checkbox } from './Checkbox';
import { Arrow } from '../../ui/icon/Arrow';
import { identityModel } from '../../../redux-modules/base/models';

let initialized = false;

function CheckboxList({
  id,
  title,
  size,
  data,
  value,
  order,
  mapping,
  handleChange,
}) {
  const openClose = useRef(null);

  useEffect(() => {
    if (initialized) {
      return;
    }
    initialized = true;

    window.jQuery(openClose.current).openClose({
      activeClass: 'active',
      opener: '.opener',
      slider: '.slide',
      animSpeed: 400,
      effect: 'slide',
    });
  }, []);

  const sortedData = _.isEmpty(order) ? data : _.sortBy((data), (v) => order.indexOf(v.key));

  return (
    <>
      <a
        href="/"
        className="filters-opener collapsed"
        data-bs-toggle="collapse"
        data-bs-target={`#filters-${id}`}
        aria-expanded="true"
      >
        {title}
      </a>
      <div className="collapse show" id={`filters-${id}`}>
        <div className="open-close-checkbox-list" ref={openClose}>
          {
            _.map(_.take(sortedData, size), (item) => (
              <Checkbox
                key={item.key}
                id={`${id}-${item.key}`}
                item={item}
                value={value}
                label={_.get(mapping, item.key, item.key)}
                handleChange={handleChange}
              />
            ))
          }
          <div className="slide">
            {
              _.map(_.takeRight(sortedData, _.size(sortedData) - size), (item) => (
                <Checkbox
                  key={item.key}
                  id={`${id}-${item.key}`}
                  item={item}
                  value={value}
                  label={_.get(mapping, item.key, item.key)}
                  handleChange={handleChange}
                />
              ))
            }
          </div>
          <a
            href="/"
            className="opener link-more"
            style={{ display: _.size(sortedData) > size ? 'block' : 'none' }}
          >
            Show &nbsp;
            <span className="more">more</span>
            <span className="less">less</span>
            <Arrow />
          </a>
        </div>
      </div>
    </>
  );
}

export { CheckboxList };

CheckboxList.propTypes = {
  id: identityModel.isRequired,
  title: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    key: identityModel.isRequired,
  })),
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.shape({}).isRequired,
  order: PropTypes.arrayOf(PropTypes.string),
  mapping: PropTypes.shape({}),
};

CheckboxList.defaultProps = {
  data: [],
  order: [],
  mapping: null,
};
